import { type InteractionsProps } from "./interfaces";
import { useInteractions } from "./useInteractions";
import { useEffect } from "react";
import { GoLink } from "react-icons/go";
import { CopyToClipboard } from "@utils/copyToClipBoard";

//components
import { BreadCrumbs, Button } from "@atoms";
import { Accordion } from "@molecules";

export const Interactions = ({ calledId, backPage }: InteractionsProps) => {
  const helper = useInteractions();

  useEffect(() => {
    (async () => {
      await helper.handleInteractions(calledId);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calledId]);

  if (helper.loading) {
    return <p>carregando...</p>;
  }

  return (
    <div>
      <BreadCrumbs items={["OS", "Chamados", "Interações"]} />
      <h1 className="text-[20px] font-[400] mb-[20px]">Interações chamado - {calledId}</h1>
      <div className="w-full ml-[5px] overflow-hidden overflow-y-auto">
        <div className="w-[97%]">
          {helper.interactions.map((item, index) => (
            <Accordion Title={`Interação ${index + 1}`}>
              <p className="w-full flex justify-between text-[14px]">
                <span className="text-[#87929D]">Data</span>
                <span className="text-end max-w-[70%]">{item.data ?? "-"}</span>
              </p>
              <p className="w-full flex justify-between text-[14px]">
                <span className="text-[#87929D]">Admin</span>
                <span className="text-end max-w-[70%]">{item.atendente ?? "-"}</span>
              </p>
              <p className="w-full flex justify-between text-[14px]">
                <span className="text-[#87929D]">Status</span>
                <span className="text-end max-w-[70%]">{item.status_item ?? "-"}</span>
              </p>
              <p className="w-full text-[14px]">
                <span className="text-[#87929D]">Mensagem</span>
                <br />
                <span
                  className="max-w-[70%]"
                  dangerouslySetInnerHTML={{
                    __html: item.comentarios ?? "-",
                  }}
                />
              </p>
              <p className="w-full text-[14px]">
                <span className="text-[#87929D]">Anexos</span>
                {item.anexo ? (
                  item.anexo.map((item) => (
                    <div className="w-full h-[40px] flex items-center border border-[#b0b8be] my-[10px] rounded-[5px]">
                      <button
                        className="bg-[white] border-0 cursor-pointer"
                        onClick={() => {
                          CopyToClipboard(item);
                        }}
                      >
                        <GoLink className="mr-[15px] ml-[15px]" />
                      </button>
                      <p className="truncate max-w-[300px]">{item}</p>
                    </div>
                  ))
                ) : (
                  <p>Sem anexos</p>
                )}
              </p>
            </Accordion>
          ))}
        </div>
      </div>

      <div className="w-full border-t border-[#D8DCDE] flex flex-col gap-[20px] bg-white mt-[15px]">
        <Button onClick={backPage}>Voltar</Button>
      </div>
    </div>
  );
};
